module.exports = __webpack_public_path__ + "static/img/banner07.3de6d929.png";